// Flow types automatically removed

import { commitMutation, graphql } from 'react-relay/legacy';
const mutation = graphql`
    mutation profileAboutMutation($input: DesignProfileBasicMutationInput!) {
        designProfileBasicMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    about
                }
            }
        }
    }
`;
export const profileAboutMutation = (environment, args) => {
    const { firmId, about } = args;
    const input = {
        serviceId: firmId,
        about,
    };
    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors) => {
            if (errors && errors.length) {
                reject(errors);
            }

            resolve(response);
        };

        const onError = error => {
            reject([error]);
        };

        try {
            commitMutation(environment, {
                mutation,
                variables: {
                    input,
                },
                onCompleted,
                onError,
            });
        } catch (error) {
            reject([error]);
        }
    });
};
